import { render, staticRenderFns } from "./999.vue?vue&type=template&id=9b2b8550&scoped=true&"
import script from "./999.vue?vue&type=script&lang=js&"
export * from "./999.vue?vue&type=script&lang=js&"
import style0 from "./999.vue?vue&type=style&index=0&id=9b2b8550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2b8550",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b2b8550')) {
      api.createRecord('9b2b8550', component.options)
    } else {
      api.reload('9b2b8550', component.options)
    }
    module.hot.accept("./999.vue?vue&type=template&id=9b2b8550&scoped=true&", function () {
      api.rerender('9b2b8550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error-page/999.vue"
export default component.exports